"use client";

import { motion, MotionConfig } from "framer-motion";

export type EventTab = "city" | "virtual";

const tabs: { id: EventTab; label: string }[] = [
  { id: "city", label: "In Your City" },
  { id: "virtual", label: "Virtual Events" },
];

interface EventToggleProps {
  value: EventTab;
  onChange: (tab: EventTab) => void;
}

export default function EventToggle({ value, onChange }: EventToggleProps) {
  return (
    <MotionConfig transition={{ type: "spring", stiffness: 400, damping: 30 }}>
      <div
        style={{
          display: "inline-flex",
          alignItems: "center",
          backgroundColor: "#f0eeeb",
          borderRadius: "999px",
          padding: "5px",
          gap: "2px",
          boxShadow: "inset 0 1px 3px rgba(0,0,0,0.08)",
        }}
        role="tablist"
        aria-label="Event type"
      >
        {tabs.map(({ id, label }) => {
          const isActive = value === id;

          return (
            <button
              key={id}
              role="tab"
              aria-selected={isActive}
              onClick={() => onChange(id)}
              style={{
                position: "relative",
                padding: "10px 28px",
                borderRadius: "999px",
                border: "none",
                background: "transparent",
                cursor: "pointer",
                fontSize: "15px",
                fontWeight: isActive ? 600 : 400,
                outline: "none",
                zIndex: 1,
                minWidth: "130px",
                WebkitTapHighlightColor: "transparent",
              }}
            >
              {isActive && (
                <motion.span
                  layoutId="active-pill"
                  style={{
                    position: "absolute",
                    inset: 0,
                    borderRadius: "999px",
                    backgroundColor: "#f47c4e",
                    zIndex: -1,
                  }}
                />
              )}

              <motion.span
                animate={{ color: isActive ? "#ffffff" : "#4A5565" }}
                transition={{ duration: 0.2 }}
                style={{ position: "relative", zIndex: 2, display: "block" }}
                className="ff_poppins font-semibold text-sm sm:text-base md:text-lg leading-5"
              >
                {label}
              </motion.span>
            </button>
          );
        })}
      </div>
    </MotionConfig>
  );
}
